import { useState } from "react";
import { useParams } from "react-router-dom";
import { Button, ErrorText, Field, Panel, Spinner } from "../../components/ui";
import { fmtAmount, fmtPct } from "../../lib/format";
import { coverImage } from "./api";
import { useExpressInterest, useMyInterests, useOpportunity } from "./hooks";

export function OpportunityDetailPage() {
  const { id } = useParams<{ id: string }>();
  const opp = useOpportunity(id);
  const interests = useMyInterests();
  const express = useExpressInterest(id as string);
  const [amount, setAmount] = useState("");
  const [message, setMessage] = useState("");

  if (opp.isLoading) {
    return (
      <div className="center-screen">
        <Spinner />
      </div>
    );
  }
  if (!opp.data) return <ErrorText error={opp.error} />;

  const o = opp.data;
  const cover = coverImage(o);
  const already = interests.data?.some((i) => i.opportunityId === o.id);

  return (
    <Panel title={o.title}>
      <div className="opportunity-detail">
        {cover && <img src={cover} alt="" />}
        <span className="tag">{o.type}</span>
        {o.expectedYield && (
          <p>
            <strong>Rendement cible :</strong> {fmtPct(o.expectedYield)}
          </p>
        )}
        {o.minTicket && (
          <p>
            <strong>Ticket minimum :</strong> {fmtAmount(o.minTicket)} FCFA
          </p>
        )}
        {o.summary && <p>{o.summary}</p>}
        {o.body && <p className="muted">{o.body}</p>}

        {already ? (
          <p className="ok-text">✓ Vous avez déjà exprimé votre intérêt pour cette opportunité.</p>
        ) : (
          <form
            className="inline-form form-stack"
            onSubmit={(e) => {
              e.preventDefault();
              express.mutate({ amountIntended: amount || undefined, message: message || undefined });
            }}
          >
            <Field
              label="Montant envisagé (FCFA)"
              inputMode="decimal"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
            />
            <Field
              label="Message (optionnel)"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
            />
            <ErrorText error={express.error} />
            <Button type="submit" disabled={express.isPending}>
              {express.isPending ? "…" : o.ctaLabel || "Je suis intéressé(e)"}
            </Button>
          </form>
        )}
      </div>
    </Panel>
  );
}
